import React from 'react';
import { ListProps, TextField } from 'react-admin';

import { TextInput, Grid, GridList, Forbidden, DateField } from '@components';
import { useExporter, useRbacList } from '@hooks';
import { CreditStatusField } from '@pages/credit/CreditStatusField';

export const CreditDeletedList = (props: ListProps) => {
  const rbacList = useRbacList();
  const exporter = useExporter({
    filename: 'Deleted Credits',
    props: {
      'id': {
        label: 'ID',
      },
      'code': {
        label: 'Verqor Code',
      },
      'accreditedName': {
        label: 'Accredited',
      },
      'status': {
        label: 'Status',
        prop: 'statusEn',
      },
      'deletedAt': {
        label: 'Removal date',
        transform: 'date',
      },
      'deletedReason': {
        label: 'Removal reason',
      },
      'deletedByAdmin.name': {
        label: 'Removal by',
      },
    },
  });

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
      exporter={exporter}
      hideRemoveButton
      confirmRestore
    >
      <Grid
        rowClick={false}
        defaultColumns={[
          'code', 'accreditedName', 'status', 'deletedAt', 'deletedReason', 'deletedByAdmin.name',
        ]}
      >
        <TextField source="id" label="ID" />
        <TextField source="code" label="Verqor code" />
        <TextField
          source="accreditedName"
          label="Accredited"
          style={{ display: 'inline-block', width: 210 }}
        />
        <CreditStatusField source="status" label="Credit status" />
        <DateField source="deletedAt" label="Removal date" />
        <TextField source="deletedReason" label="Removal reason" />
        <TextField source="deletedByAdmin.name" label="Removal by" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" label="Search" alwaysOn style={{ width: 220 }} />,
];
